module.exports = __webpack_public_path__ + "static/img/14043D_5_6_R_20200721_fit.a391437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14043D_5_6_R_20200721_fit.png
// module id = CLat
// module chunks = 0